export function isCourseAllowed(item) {
  return Boolean(item);
}

export function filterAllowedCourses(courses) {
  if (!Array.isArray(courses)) {
    return [];
  }

  // Keep the destination default safe: filtering must be configuration-driven
  // if a deployment needs to restrict visible courses later.
  return courses.filter(isCourseAllowed);
}
